import { shape, string, number, arrayOf, bool } from 'prop-types';

export const menuPropTypes = arrayOf(
  shape({
    id: number,
    menuableId: number,
    menuableType: string,
    price: number,
    priceCurrency: string,
    menuable: shape({
      id: number,
      name: string
    }),
    variants: arrayOf(
      shape({
        id: number,
        menuableId: number,
        menuableType: string
      })
    )
  })
);

export const itemPropTypes = shape({
  // TODO: this shape isn't defined yet
  menuableType: string,
  quantity: number,
  appliedPromos: shape,
  unitPrice: number,
  extras: number,
  subtotal: number,
  discount: number,
  total: number.isRequired,
  name: string.isRequired,
  menuableId: number.isRequired,
  itemName: string,
  description: string.isRequired
});

export const variantPropTypes = shape({
  name: string.isRequired,
  value: number.isRequired,
  price: number,
  itemName: string.isRequired,
  description: string.isRequired
});

export const menuItemPropTypes = shape({
  id: number.isRequired,
  price: number,
  quantityOnCart: number,
  menuable: shape({
    id: number.isRequired,
    name: string.isRequired,
    category: string,
    description: string.isRequired,
    pictures: arrayOf(
      shape({
        id: number,
        url: string
      })
    ),
    isAlcohol: bool
  }),
  variants: arrayOf(variantPropTypes)
});

export const nutritionalInfoPropTypes = shape({
  id: number.isRequired,
  portions: string.isRequired,
  grams: number.isRequired,
  calories: number.isRequired
});
